import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'carm-main-footer-bottom-section',
  templateUrl: './main-footer-bottom-section.component.html',
  styleUrls: ['./main-footer-bottom-section.component.scss'],
})
export class MainFooterBottomSectionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
